module.exports = __webpack_public_path__ + "public/images/CookieLock.2ae442a3bcd5111eaef7ac2c25b33b02.png";